import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ConnectRestService } from '../services/connect-rest.service';
import { Router, ActivatedRoute } from '@angular/router';
import { EnglishTranslation, MalayTranslation, ExternalLinks, ProductCode } from '../app.constants';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { DataStoreService } from '../data-store.service';

declare var $: any;

@Component({
  selector: 'app-declaration',
  templateUrl: './declaration.component.html',
  styleUrls: ['./declaration.component.scss']
})

export class DeclarationComponent implements OnInit, AfterViewInit {
  Declaration : FormGroup;
  isSecondDirector: boolean = false;
  IsOneCollectSelected: string;
  english: boolean = true;
  textContent: any;
  TermsAndConditions: any;
  displayNote:boolean = true;
  IsBusinessDebitCards: boolean;
  isEditMode: boolean = false;

  constructor(
    private connect: ConnectRestService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private dataStoreService: DataStoreService,
    private formBuilder: FormBuilder) {
      this.Declaration= this.formBuilder.group({
        Radio: this.formBuilder.group({radio_declare : [{ value: '', disabled: this.isSecondDirector }, Validators.required]}),
        TermsAndConditions: this.formBuilder.group({})
      });
      
      //used to prevent back button --- added by Sonny
      sessionStorage.currentPage = window.location.href;
    }

  
     
  async onSubmit() {
    this.callSaveRequest();
  }

  async callSaveRequest() {
    var data = { Declaration : this.Declaration.get(['Radio','radio_declare']).value=="Yes" ? "true" : "false" };
    var ServResponse = await this.restConnect(data, "S0110");
    if (ServResponse.Status == "Success") {
        this.router.navigate(['/director-confirm']);
    }
  }

  async restConnect(data, reqID) {
    this.connect.consoleLog("data value", data)
    var ServResponse = await this.connect.connectRest(data, reqID, '');
    return ServResponse;
  }

  ngOnInit() {
    this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.DeclarationScreen : MalayTranslation.DeclarationScreen;
    const flowID = JSON.parse(sessionStorage.getItem('ServiceHeader')).Flow;
    if (flowID == 2) {
      this.isSecondDirector = true;
      $(".radio-item").css("opacity", ".5");
      $(":radio").prop('disabled', true);
    }
    
    this.getRequest(flowID)
    .then(() => {
      var currentProduct = sessionStorage.getItem('currentProduct');
      this.english = sessionStorage.getItem('language') !== 'ms' ? true : false;
      if (currentProduct == ProductCode.eBizi) {
        this.TermsAndConditions = this.english ? ExternalLinks.eBizi.English : ExternalLinks.eBizi.Malay;
      } else if (currentProduct ==ProductCode.Access) {
        this.TermsAndConditions = ExternalLinks.BusinessAccess.English;
        this.displayNote = false;
      } else if (currentProduct == ProductCode.Signature) {
        this.TermsAndConditions = ExternalLinks.BusinessSignature.English;
        this.displayNote = false;
      }  
      else {
        this.TermsAndConditions = this.english ? ExternalLinks.eBiz.English : ExternalLinks.eBiz.Malay;
      }  

      
      const group = this.Declaration.get('TermsAndConditions') as FormGroup;

      this.TermsAndConditions.forEach(tnc => {
        if ((this.IsOneCollectSelected !== "Yes" && tnc.code == 'TCGT') || (!this.IsBusinessDebitCards && tnc.code == 'BDCA')) {
          tnc['hide'] = true;
          return;
        }
        tnc['hide'] = false;
        group.addControl(
          tnc['code'],
          new FormControl('', Validators.required)
        )
      });
    });
  }

  async ngAfterViewInit() {
    if(await this.dataStoreService.getAAStatus()) {
      this.dataStoreService.setAAData('declaration');
    }
  }

  async getRequest(flowID){
    const ServResponse = await this.restConnect('', "R0110");
    if (ServResponse.Status == "Success") {
      if (flowID == 2) {
        const declaration = ServResponse['Declaration'] === "true" ? 'Yes' : 'No';
        this.Declaration.get(['Radio','radio_declare']).setValue(declaration);
      }

      this.IsOneCollectSelected = ServResponse['IsOneCollectSelected'];
      this.IsBusinessDebitCards = ServResponse['IsBusinessDebitCard'];
    }
  }

  onLinkClick(code){
    this.Declaration.get(['TermsAndConditions',code]).setValue(true);
    this.validateLinks();
  }

  validateLinks(){
    this.Declaration.updateValueAndValidity();
    if(this.Declaration.get("TermsAndConditions").status == 'VALID'){
      $("#link_error_container").css("display", "none");
    }else{
      $("#link_error_container").html(this.textContent.viewError);
    }
  }

  onPrevious(){
    if (this.isEditMode) {
      this.router.navigate(['/business-banking', {edit:true}]);
    } else if(sessionStorage.constitution=="C"){
      this.router.navigate(['/company-constitution']);
    }else{
      this.router.navigate(['/signature']);
    }
  }
}
